import React from 'react';
import { Box, Fade, Paper, Typography } from '@mui/material';
import type { SxProps, Theme } from '@mui/material/styles';

interface FormSectionProps {
  children: React.ReactNode;
  title?: string;
  action?: React.ReactNode;
  sx?: SxProps<Theme>;
  fadeIn?: boolean;
  fadeTimeout?: number;
}

const FormSection: React.FC<FormSectionProps> = ({
  children,
  title,
  action,
  sx,
  fadeIn,
  fadeTimeout = 250,
}) => {
  const content = (
    <Paper
      variant="outlined"
      sx={{
        display: 'flex',
        flexDirection: 'column',
        gap: 2,
        p: 2,
        ...sx,
      }}
    >
      {title || action ? (
        <Box
          sx={{
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'space-between',
          }}
        >
          {title ? (
            <Typography variant="caption" color="text.secondary">
              {title}
            </Typography>
          ) : (
            <span />
          )}
          {action}
        </Box>
      ) : null}
      {children}
    </Paper>
  );

  if (fadeIn === undefined) {
    return content;
  }

  return (
    <Fade
      in={fadeIn}
      timeout={fadeTimeout}
      mountOnEnter={true}
      unmountOnExit={true}
    >
      {content}
    </Fade>
  );
};

export default FormSection;
